function logRMAAuth(type, value, success) {        
    if (type && value) {
        $.get("/api/rma/log", { rmaType: type, rmaValue: value, success: success});
    }
}